class DetailsDisclosure extends HTMLElement {
  constructor() {
    super();
    this.mainDetailsToggle = this.querySelector("details");
    this.content =
      this.mainDetailsToggle.querySelector("summary").nextElementSibling;

    this.mainDetailsToggle.addEventListener(
      "focusout",
      this.onFocusOut.bind(this),
    );
    this.mainDetailsToggle.addEventListener("toggle", this.onToggle.bind(this));
  }

  onFocusOut() {
    setTimeout(() => {
      if (!this.contains(document.activeElement)) this.close();
    });
  }

  onToggle() {
    if (!this.animations) this.animations = this.content.getAnimations();

    if (this.mainDetailsToggle.hasAttribute("open")) {
      this.animations.forEach((animation) => animation.play());
    } else {
      this.animations.forEach((animation) => animation.cancel());
    }
  }

  close() {
    this.mainDetailsToggle.removeAttribute("open");
    this.mainDetailsToggle
      .querySelector("summary")
      .setAttribute("aria-expanded", false);
  }
}

customElements.define("details-disclosure", DetailsDisclosure);

class HeaderMenu extends DetailsDisclosure {
  constructor() {
    super();
    this.header = document.querySelector(".header-wrapper");
  }

  onToggle() {
    if (!this.header) return;
    this.header.preventHide = this.mainDetailsToggle.open;

    if (
      document.documentElement.style.getPropertyValue(
        "--header-bottom-position-desktop",
      ) !== ""
    )
      return;
    document.documentElement.style.setProperty(
      "--header-bottom-position-desktop",
      `${Math.floor(this.header.getBoundingClientRect().bottom)}px`,
    );
  }
}

customElements.define("header-menu", HeaderMenu);

// handle split menus (collection items with subcollections)
document.addEventListener("DOMContentLoaded", () => {
  document
    .querySelectorAll(".header__split-menu, .menu-drawer__split-menu")
    .forEach((splitSummary) => {
      const toggleButton = splitSummary.querySelector(
        ".header__split-menu-toggle, .menu-drawer__split-menu-toggle",
      );
      const link = splitSummary.querySelector(
        ".header__split-menu-link, .menu-drawer__split-menu-link",
      );
      const detailsElement = splitSummary.parentElement;

      if (!toggleButton || !link) return;

      const isMobileDrawer = splitSummary.classList.contains(
        "menu-drawer__split-menu",
      );

      // only handle desktop with JS
      if (!isMobileDrawer) {
        splitSummary.addEventListener("click", (event) => {
          event.preventDefault();
          const clickedText =
            event.target.tagName === "SPAN" && link.contains(event.target);

          if (clickedText) {
            window.location.href = link.href;
          } else {
            const isOpen = detailsElement.hasAttribute("open");
            if (isOpen) {
              detailsElement.removeAttribute("open");
              toggleButton.setAttribute("aria-expanded", "false");
            } else {
              detailsElement.setAttribute("open", "");
              toggleButton.setAttribute("aria-expanded", "true");
            }
          }
        });
      }
    });
});
